import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects old-format URLs (e.g. /licitatii/SCN123) to new SEO-friendly format.
 * Uses "detalii" as a fallback slug since we don't have the title at redirect time.
 */
const LegacyRedirect = ({ basePath }) => {
  // Route param is named ":noticeNo" for auction paths and ":id" for /proiecte.
  // Read whichever is present so slug-less links never redirect to ".../undefined".
  const { noticeNo, id } = useParams();
  const code = noticeNo ?? id;
  return <Navigate to={`${basePath}/detalii/${code}`} replace />;
};

export default LegacyRedirect;
